var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51203 12C4.74775 15.4965 8.08286 18 12.0002 18C15.9175 18 19.2526 15.4966 20.4884 12C19.2527 8.50345 15.9175 6 12.0002 6C8.08286 6 4.74776 8.50342 3.51203 12ZM1.50396 11.7003C2.90538 7.23842 7.07329 4 12.0002 4C16.9271 4 21.0951 7.23846 22.4965 11.7004C22.5577 11.8955 22.5577 12.1046 22.4965 12.2997C21.095 16.7616 16.9271 20 12.0002 20C7.07329 20 2.90535 16.7615 1.50396 12.2996C1.44269 12.1045 1.44269 11.8954 1.50396 11.7003ZM11.9998 10C10.8952 10 9.99976 10.8954 9.99976 12C9.99976 13.1046 10.8952 14 11.9998 14C13.1043 14 13.9998 13.1046 13.9998 12C13.9998 10.8954 13.1043 10 11.9998 10ZM7.99976 12C7.99976 9.79086 9.79062 8 11.9998 8C14.2089 8 15.9998 9.79086 15.9998 12C15.9998 14.2091 14.2089 16 11.9998 16C9.79062 16 7.99976 14.2091 7.99976 12Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6c3059f26877ab7815abdd5231a32d62.svg";
export { ForwardRef as ReactComponent };